export const GRAPHQL_VARIABLES = {
  record: {
    firstName: 'John',
    lastName: 'SUN'
  },
  filter: {
    _id: '5fc44c1f84ffd06759c1a1e3'
  }
};

export const QUERY = `
  mutation customersUpdateOne ($record: UpdateOnecustomersInput!, $filter: AutoFilledFilterUpdateOnecustomersInput!, $sort: SortUpdateOnecustomersInput, $skip: Int) {
    customersUpdateOne (record: $record, filter: $filter, sort: $sort, skip: $skip) {
        recordId
        record {
            email
            phone
            firstName
            lastName
            companyName
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            companyId
            bkUser
            bkCompany
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
